module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h2', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To")])]), _vm._v(" "), _c('h2', {
    staticClass: "dedicationText1"
  }, [_vm._v("HENRY WILLIAMSON")]), _vm._v(" "), _c('h2', {
    staticClass: "dedicationText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("at whose suggestion this book was begun, with whose encouragement and help it was written and ended")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-467323be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WingedVictory_dedication.vue
// module id = 63
// module chunks = 0